import { Box, Typography, useTheme, Button } from "@mui/material";
import { tokens } from "../../theme";
import { useState, useEffect, useMemo, useRef } from "react";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { djangoApi } from "../../utils/axios/axios.utils";

import UserCard from "./user-card";
import TableSkeleton from "./skeleton-table";

import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';

import UserForm from "../../components/users-comps/user-form";
import UserContractPage from "../../components/users-comps/user-contract";

import useMediaQuery from '@mui/material/useMediaQuery';
import classes from './modal.module.css';

import { useLocation } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

import { setDocsTypes, setSellers } from '../../store/sellers/sellers.action';
import { selectSellers } from '../../store/sellers/sellers.selector';

import supabase from "./supabase";
import { selectIsStaffUser } from "../../store/user/user.selector";
import { selectTypeDocs } from "../../store/sellers/sellers.selector";

import {
    ToggleButton,
    ToggleButtonGroup,
} from '@mui/material';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import RevendedoresDashboard from "../gerencial-vanessa";
import { exportToExcel } from "./export-user-excel";
import { exportToPDF } from "./export-pdf";

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

import SelectKitPromissoryModal from "../../components/users-comps/select-kit-promissory-modal";


const EXCLUDE_EMAILS = ["financeiro@pitayajoias.com.br", "vaabrun@gmail.com", "vanessabbrun@gmail.com", "patamarcelo@gmail.com"]

const UsersPage = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const dispatch = useDispatch();
    const isStaff = useSelector(selectIsStaffUser);
    const documentsTypes = useSelector(selectTypeDocs)


    const [isLoading, setIsLoading] = useState(true);

    const sellersData = useSelector(selectSellers);
    const [filterSeller, setFilterSeller] = useState('able');

    const isMobile = useMediaQuery('(min-width: 800px)');

    const [onlyEmailData, setOnlyEmailData] = useState([]);

    const [dataUserToEdit, setdataUserToEdit] = useState({});
    const [hasFormErrors, setHasFormErrors] = useState(false);

    const [showInfo, setShowInfo] = useState(false);

    // Modal Usuário
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // Modal Contrato
    const [openContract, setOpenContract] = useState(false);
    const handleOpenContract = () => setOpenContract(true);

    const [standalonePromissory, setStandalonePromissory] = useState(null);

    const handleCloseContract = () => {
        setOpenContract(false);
        setIncludePromissory(false);
        setSelectedPromissoryKit(null);
        setStandalonePromissory(null);
    };
    const [userData, setUserData] = useState(null);


    const [dataToExport, setDataToExport] = useState([]);

    const [searchTerm, setSearchTerm] = useState("");
    const searchInputRef = useRef(null);

    const [view, setView] = useState('list');

    const [openPromissorySelector, setOpenPromissorySelector] = useState(false);
    const [selectedPromissoryKit, setSelectedPromissoryKit] = useState(null);
    const [includePromissory, setIncludePromissory] = useState(false);
    const [sellerKitsForPromissory, setSellerKitsForPromissory] = useState([]);
    const [isLoadingSellerKits, setIsLoadingSellerKits] = useState(false);




    const focusSearchInput = () => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
            // opcional:
            // searchInputRef.current.select();
        }
    };

    const { state, pathname } = useLocation(); // caso use depois

    console.log('documentsTypes', documentsTypes)

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? '80%' : '100%',
        maxWidth: '80%',
        height: '95vh',
        overflow: 'scroll',
        overflowX: 'hidden',
        bgcolor: '#E0E0E0',
        border: '2px solid #000',
        boxShadow: 24,
        p: isMobile ? 4 : 2,
    };

    const styleContract = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? '80%' : '100%',
        maxWidth: '100%',
        height: '100%',
        overflow: 'scroll',
        overflowX: 'hidden',
        bgcolor: 'white',
        color: 'black',
        boxShadow: 24,
        p: isMobile ? 4 : 2,
    };

    const handlerExporReport = () => {
        exportToExcel(dataToExport);
    };

    const handlerExporReportPdf = () => {
        exportToPDF(dataToExport);
    };

    const handleOpenEditUser = (userData) => {
        handleOpen();
        setdataUserToEdit(userData);
    };

    // E-mails únicos para validação no formulário
    useEffect(() => {
        if (sellersData.length > 0) {
            const onlyEmail = Array.isArray(sellersData) && sellersData.map((data) => data.email);
            setOnlyEmailData(onlyEmail);
        }
    }, [sellersData]);

    useEffect(() => {
        // Sempre que:
        // - mudar o pathname (entrou de novo na rota)
        // - a view for "list"
        // - fechar modais
        // tenta focar o input
        if (view === "list") {
            // pequeno delay pra garantir que o TextField já está no DOM
            setTimeout(() => {
                focusSearchInput();
            }, 0);
        }
    }, [pathname, view, open, openContract]);

    // Normaliza texto para permitir buscas sem acento, pontuação ou formatação
    const normalizeSearchValue = (value) => {
        return String(value ?? "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^\p{L}\p{N}\s]/gu, " ")
            .replace(/\s+/g, " ")
            .trim()
            .toLowerCase();
    };

    // Junta todos os campos pesquisáveis da vendedora em um único texto
    const getSellerSearchText = (seller) => {
        const searchableFields = [
            // Identificação
            seller.id,
            seller.nome,
            seller.name,
            seller.full_name,
            seller.first_name,
            seller.username,
            seller.slug,

            // Contato
            seller.email,
            seller.telefone,
            seller.telefone_secundario,
            seller.insta_link,

            // Documentos e dados pessoais
            seller.cpf,
            seller.nome_mae,
            seller.data_nascimento,

            // Empresa
            seller.nome_empresa,

            // Endereço residencial
            seller.end_logradouro,
            seller.end_numero,
            seller.end_complemento,
            seller.end_bairro,
            seller.end_cep,
            seller.end_municipio,

            // Endereço comercial
            seller.end_logradouro_comercial,
            seller.end_numero_comercial,
            seller.end_complemento_comercial,
            seller.end_bairro_comercial,
            seller.end_cep_comercial,
            seller.end_municipio_comercial,

            // Endereço de entrega
            seller.end_logradouro_entrega,
            seller.end_numero_entrega,
            seller.end_complemento_entrega,
            seller.end_bairro_entrega,
            seller.end_cep_entrega,
            seller.end_municipio_entrega,

            // Observações
            seller.observacao,
            seller.obs_to_display,
        ];

        return normalizeSearchValue(
            searchableFields
                .filter((value) => value !== null && value !== undefined)
                .join(" ")
        );
    };


    const searchableSellers = useMemo(() => {
        if (!Array.isArray(sellersData)) {
            return [];
        }

        return sellersData.map((seller) => ({
            seller,
            searchText: getSellerSearchText(seller),
        }));
    }, [sellersData]);

    const filteredSellers = useMemo(() => {
        let list = searchableSellers;

        if (filterSeller === "able") {
            list = list.filter(
                ({ seller }) => seller.firebase_disabled === false
            );
        } else if (filterSeller === "desable") {
            list = list.filter(
                ({ seller }) => seller.firebase_disabled === true
            );
        } else if (filterSeller === "failurePayment") {
            list = list.filter(
                ({ seller }) =>
                    Array.isArray(seller?.kits_inadimplentes) &&
                    seller.kits_inadimplentes.length > 0
            );
        }

        const normalizedTerm = normalizeSearchValue(searchTerm);

        if (!normalizedTerm) {
            return list.map(({ seller }) => seller);
        }

        const searchWords = normalizedTerm
            .split(" ")
            .filter(Boolean);

        return list
            .filter(({ searchText }) =>
                searchWords.every((word) => searchText.includes(word))
            )
            .map(({ seller }) => seller);
    }, [searchableSellers, filterSeller, searchTerm]);
    console.log('filteredSellers: ', filteredSellers[0])


    const filteredSellersCount = useMemo(() => {
        return filteredSellers.filter((seller) => {
            const sellerEmail = String(seller?.email ?? "")
                .trim()
                .toLowerCase();

            return !EXCLUDE_EMAILS.includes(sellerEmail);
        }).length;
    }, [filteredSellers]);


    // ======== Fetch lazy de tipos de documentos ========
    const getDocumentsTypes = async () => {
        console.log('pegando os doc types')
        if (documentsTypes && documentsTypes.length > 0) return; // já carregado
        console.log('pegando os doc types after if')
        try {
            const res = await djangoApi.get("sellers/tipos-documentos/", {
                headers: {
                    Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                    "Content-Type": "application/json",
                },
            });

            const { data } = res;
            dispatch(setDocsTypes(data))
        } catch (err) {
            console.log("Erro ao pegar os tipos", err);
            // window.alert(err);
        }
    };

    // ======== Fetch de sellers (com cache via Redux) ========
    useEffect(() => {
        const getSellersData = async () => {
            setIsLoading(true);
            try {
                const res = await djangoApi.get("sellers/sellers/get_sellers", {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json",
                    },
                });

                const { data, failure_payments } = res.data;
                console.log('data serllers:::', data)

                const kitsByUser = {};
                if (Array.isArray(failure_payments)) {
                    failure_payments.forEach((kit) => {
                        const sellerId = kit.seller__pk;
                        if (!kitsByUser[sellerId]) {
                            kitsByUser[sellerId] = [];
                        }
                        kitsByUser[sellerId].push({
                            ...kit,
                        });
                    });
                }

                const unified = data.map((user) => ({
                    ...user,
                    kits_inadimplentes: kitsByUser[user.id] || [],
                }));

                dispatch(setSellers(unified));
            } catch (err) {
                console.log("Erro ao pegar as Vendedoras", err);
                // window.alert(err);
            } finally {
                setIsLoading(false);
            }
        };

        if (sellersData.length === 0) {
            // Só consulta se ainda não temos nada no Redux
            getSellersData();
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // roda apenas no mount

    const handleChange = (event) => {
        setFilterSeller(event.target.value);
    };



    const handleChangeList = (_, nextView) => {
        if (nextView !== null) {
            setView(nextView);

            // Se trocar pra visão de cards, garantir que temos tipos de documentos
            if (nextView === 'card' && (!documentsTypes || documentsTypes.length === 0)) {
                getDocumentsTypes();
            }
        }
    };



    const getSellerKitsForPromissory = async (sellerId) => {
        setIsLoadingSellerKits(true);
        try {
            const res = await djangoApi.get(
                `products/register_prods/${sellerId}/get_kit_seller_beta_version/`,
                {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const kits = Array.isArray(res?.data?.dados) ? res.data.dados : [];
            setSellerKitsForPromissory(kits);
        } catch (err) {
            console.log("Erro ao buscar kits para promissória:", err);
            setSellerKitsForPromissory([]);
        } finally {
            setIsLoadingSellerKits(false);
        }
    };

    const handleOpenContractWithPromissory = async (sellerData) => {
        setUserData(sellerData);
        setSelectedPromissoryKit(null);
        setStandalonePromissory(null);
        setIncludePromissory(false);
        setOpenPromissorySelector(true);

        await getSellerKitsForPromissory(sellerData.id);
    };

    const handleConfirmPromissoryKit = (kit) => {
        setSelectedPromissoryKit(kit);
        setStandalonePromissory(null);
        setIncludePromissory(true);
        setOpenPromissorySelector(false);
        setOpenContract(true);
    };

    const handleConfirmStandalonePromissory = ({
        value,
        dueDate,
    }) => {
        setSelectedPromissoryKit(null);

        setStandalonePromissory({
            value,
            dueDate,
        });

        setIncludePromissory(true);
        setOpenPromissorySelector(false);
        setOpenContract(true);
    };


    if (isLoading) {
        return <TableSkeleton />;
    }

    if (!isLoading && sellersData.length === 0) {
        return (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: 'center',
                    height: "100%",
                    paddingTop: "40px",
                    width: "100%",
                }}
            >
                <Typography variant="h3" color={colors.primary[200]}>
                    Sem Dados para mostrar
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                height: "100%",
                paddingTop: "40px",
            }}
        >
            <Box
                sx={{
                    padding: '20px',
                    display: 'flex',
                    justifyContent: "space-between",
                    height: '100px',
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        width: '400px',
                        gap: '30px',
                        alignItems: "end",
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex'
                        }}
                    >
                        {isStaff && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    paddingTop: '20px',
                                }}
                            >
                                <Tooltip title="Mostrar quantidade">
                                    <IconButton
                                        onClick={() => setShowInfo(!showInfo)}
                                        color={!showInfo ? "success" : "warning"}
                                    >
                                        {!showInfo ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </Tooltip>

                                {showInfo && (
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontSize: "12px",
                                            margin: "0px",
                                            color:
                                                filterSeller === "todas"
                                                    ? "whitesmoke"
                                                    : filterSeller === "able"
                                                        ? colors.greenAccent[200]
                                                        : colors.redAccent[200],
                                        }}
                                    >
                                        {filteredSellersCount}
                                    </Typography>
                                )}
                            </div>
                        )}
                        <Box display="flex" alignItems="flex-end" ml={2}>
                            <ToggleButtonGroup
                                value={view}
                                exclusive
                                onChange={handleChangeList}
                                size="small"
                            >
                                <ToggleButton value="list" aria-label="List view">
                                    <ViewListIcon />
                                </ToggleButton>
                                <ToggleButton value="card" aria-label="Card view">
                                    <ViewModuleIcon />
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                    </Box>

                    {view === 'list' && (
                        <Box sx={{ display: "flex", flexDirection: "row", gap: 5 }}>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={filterSeller}
                                label="filterSeller"
                                size="small"
                                onChange={handleChange}
                                sx={{
                                    height: "30px",
                                    color: "whitesmoke !important",
                                }}
                            >
                                <MenuItem value={"todas"}>Todas</MenuItem>
                                <MenuItem value={"able"}>Ativas</MenuItem>
                                <MenuItem value={"desable"}>Desativadas</MenuItem>
                                <MenuItem value={"failurePayment"}>Pgto Pendente</MenuItem>
                            </Select>

                            <TextField
                                inputRef={searchInputRef}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                size="small"
                                variant="outlined"
                                placeholder="Buscar por nome, mãe, CPF, telefone ou endereço"
                                sx={{
                                    minWidth: 260,
                                    backgroundColor: "rgba(255,255,255,0.08)",
                                    borderRadius: 1,
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon fontSize="small" />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                    )}

                </Box>

                <Box sx={{ display: 'flex', gap: '20px' }}>
                    <Box
                        sx={{
                            height: '50px',
                            display: 'flex',
                            alignItems: 'end',
                            gap: '15px',
                        }}
                    >
                        <Button
                            onClick={handlerExporReportPdf}
                            variant="contained"
                            disabled={dataToExport.length === 0}
                            color="info"
                            size="small"
                            sx={{ color: 'white' }}
                        >
                            Pdf
                        </Button>
                        <Button
                            onClick={handlerExporReport}
                            variant="contained"
                            disabled={dataToExport.length === 0}
                            color="info"
                            size="small"
                            sx={{ color: 'white' }}
                        >
                            Relatório
                        </Button>
                    </Box>
                    <Box sx={{ height: '50px', display: 'flex', alignItems: 'end' }}>
                        <Button
                            onClick={handleOpen}
                            variant="contained"
                            color="success"
                            size="small"
                            sx={{ color: 'white' }}
                        >
                            Adicionar
                        </Button>
                    </Box>
                </Box>
            </Box>

            {view === 'list' && (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                        paddingBottom: '10px',
                        overflow: "auto",
                        backgroundColor: colors.pink[400],
                    }}
                >
                    {filteredSellers.length > 0 &&
                        filteredSellers.map((data, i) => (
                            <UserCard
                                data={data}
                                key={i}
                                handleOpenEditUser={handleOpenEditUser}
                                handleOpenContract={handleOpenContract}
                                handleOpenContractWithPromissory={handleOpenContractWithPromissory}
                                setUserData={setUserData}
                                supabase={supabase}
                                setDataToExport={setDataToExport}
                                dataToExport={dataToExport}
                            />
                        ))}
                </Box>
            )}

            {view !== 'list' && (
                <RevendedoresDashboard documentsTypes={documentsTypes} />
            )}

            {/* Modal Usuário */}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-user-form"
                aria-describedby="modal-modal-user-form-data"
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
                className={hasFormErrors ? classes.custommodal : undefined}

            >
                <Fade in={open}>
                    <Box sx={style}>
                        <UserForm
                            handleClose={handleClose}
                            dataUser={dataUserToEdit}
                            setdataUserToEdit={setdataUserToEdit}
                            modalOpen={open}
                            onlyEmailData={onlyEmailData}
                            setHasFormErrors={setHasFormErrors}
                        />
                    </Box>
                </Fade>
            </Modal>


            <SelectKitPromissoryModal
                open={openPromissorySelector}
                onClose={() => setOpenPromissorySelector(false)}
                kits={sellerKitsForPromissory}
                onConfirm={handleConfirmPromissoryKit}
                onConfirmStandalone={handleConfirmStandalonePromissory}
                isLoading={isLoadingSellerKits}
            />

            {/* Modal Contrato */}
            <Modal
                open={openContract}
                onClose={handleCloseContract}
                aria-labelledby="modal-modal-user-contract"
                aria-describedby="modal-modal-user-contract-data"
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={openContract}>
                    <Box sx={styleContract}>
                        <UserContractPage
                            handleClose={handleCloseContract}
                            dataFromUser={userData}
                            includePromissory={includePromissory}
                            selectedKit={selectedPromissoryKit}
                            standalonePromissory={standalonePromissory}
                        />
                    </Box>
                </Fade>
            </Modal>
        </Box>
    );
};

export default UsersPage;
